module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-dialog', {
    attrs: {
      "width": "1000",
      "title": "Invoice Sample Data",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "close": function($event) {
        _vm.$emit('onClose')
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "reference",
      "label": "Reference",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "invoiceDate",
      "label": "Invoice Date",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "customerName",
      "label": "Customer Name",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "amount",
      "label": "Amount",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "currencyCode",
      "label": "Currency Code",
      "width": "125"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "introduction",
      "label": "Introduction",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "productNumber",
      "label": "Product Number",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "quantity",
      "label": "Quantity",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "price",
      "label": "Price",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "accountCode",
      "label": "Account Code",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "taxType",
      "label": "Tax type",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "tax",
      "label": "Tax",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "invoiceDueDate",
      "label": "Invoice Due Date",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "invoiceNumber",
      "label": "Invoice Number",
      "width": "110"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Invoice date format should be "), _c('b', [_vm._v("MM/dd/yyyy")]), _vm._v(" format. You can download sample file "), _c('a', {
    attrs: {
      "href": "https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Invoice_Import_Template.csv"
    }
  }, [_vm._v("here")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2770bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvoicePopup.vue
// module id = 244
// module chunks = 1